import moment from 'moment';
import column from '../../../../../common/list-table/helpers/columns';

export default (data, setData, checkboxParameterPopulator, checkedList, setIsFormValid) => {
  const {
    CheckboxColumn, NotFilteredTextColumn, EditableCheckboxColumn, EditableDatePickerColumn,
  } = column(data);

  const identifier = (row) => row.original.handlerId;
  const isHeaderChecked = checkedList.length === (Array.isArray(data) ? data.length : 0);

  const handleOnError = (error, value, rowData) => {
    if (error !== '' && checkedList.includes(rowData.handlerId)) setIsFormValid(false);
  };

  const ValidFromPropsPopulator = (rowData) => {
    let props = {
      minDate: moment(),
      minDateMessage: 'Date should not be past date',
      onError: (error, value) => handleOnError(error, value, rowData),
    };
    if (rowData.validTo !== null) {
      props = {
        ...props,
        maxDate: rowData.validTo,
        maxDateMessage: 'Date should not be after "Valid to" date',
      };
    }
    return props;
  };

  const ValidToPropsPopulator = (rowData) => {
    let props = {
      minDate: moment(),
      onError: (error, value) => handleOnError(error, value, rowData),
    };
    if (rowData.validFrom !== null) {
      props = {
        ...props,
        minDate: moment(rowData.validFrom),
        minDateMessage: 'Date should not be before "Valid from" date',
      };
    }
    return props;
  };

  return [
    {
      Header: '',
      columns: [
        new CheckboxColumn('', '', '', {
          ...checkboxParameterPopulator(checkedList), identifier, isHeaderChecked,
        }),
        new NotFilteredTextColumn('Handler name', 'handlerName').withWidth(450),
        new EditableCheckboxColumn('Print receipt', 'printReceipt', true, data, setData).withWidth(100),
        new EditableDatePickerColumn('Valid from', 'validFrom', true, data, setData, ValidFromPropsPopulator),
        new EditableDatePickerColumn('Valid to', 'validTo', true, data, setData, ValidToPropsPopulator),
      ],
    },
  ];
};
